export const CHAT_CONVERSATION_HEADER_SAFE_TOP_CLASS = "safe-area-top md:pt-0"

export const CHAT_CONVERSATION_HEADER_LAYER_CLASSNAME =
  "top-0 right-0 left-0 isolate shrink-0"

export const chatConversationFooterFadeStyle = {
  maskImage:
    "linear-gradient(to top, #000 0%, #000 16%, rgba(0,0,0,0.82) 36%, rgba(0,0,0,0.35) 58%, rgba(0,0,0,0.08) 78%, transparent 100%)",
  WebkitMaskImage:
    "linear-gradient(to top, #000 0%, #000 16%, rgba(0,0,0,0.82) 36%, rgba(0,0,0,0.35) 58%, rgba(0,0,0,0.08) 78%, transparent 100%)",
  maskSize: "100% 100%",
  WebkitMaskSize: "100% 100%",
  maskRepeat: "no-repeat",
  WebkitMaskRepeat: "no-repeat",
  backgroundImage:
    "linear-gradient(to top, hsl(var(--background) / 0.92) 0%, hsl(var(--background) / 0.55) 20%, hsl(var(--background) / 0.18) 46%, hsl(var(--background) / 0.04) 72%, transparent 100%)",
} as const

export const chatConversationFooterFadeLayerClassName =
  "pointer-events-none absolute inset-0 z-0 w-full backdrop-blur-md"
